import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixFactory,
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import { addMinutes } from "date-fns";
import { z } from "zod";

type ReservationCommon = {
    readonly _id: string;
    readonly _type: "RESERVATION";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly timeOutAt: IsoAndUnixTimestamp;
};

const reservationCommonFactory = (timeOutInMinutes = 30): ReservationCommon => {
    const reservationCommon: ReservationCommon = {
        _id: generateId({ prefix: "reservation__" }),
        _createdAt: nowIsoAndUnix(),
        _type: "RESERVATION",
        timeOutAt: isoAndUnixFactory(addMinutes(new Date(), timeOutInMinutes)),
    };

    return reservationCommon;
};

const reservationCommonZodSchema: z.ZodSchema<ReservationCommon> = z.object({
    _id: idZodSchema,
    _type: z.literal("RESERVATION"),
    _createdAt: isoAndUnixZodSchema,
    timeOutAt: isoAndUnixZodSchema,
});

export { reservationCommonFactory, reservationCommonZodSchema };
export type { ReservationCommon };
